import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import DepartmentListItemNew from "./DepartmentListItemNew";
import {
  updateIftCheckList,
} from "redux/actions";

import "./sidebar-new.scss";
import "rc-slider/assets/index.css";

const SidebarNew = ({
  departmentTree,
  isMobileSidebar,
  redirectBaseUrl,
  isCateringDepartment,
  querySearchKey,
}) => {
  const dispatch = useDispatch();
  const headerSection = useSelector(
    ({ common }) => common.commonDetailsData.header_section
  );
  const cateringBannerImage = headerSection?.catering_page_bg_banners;

  const [isShowDepartmentTree, setShowDepartmentTree] = useState(true);

  useEffect(() => {
    dispatch(updateIftCheckList("coupon"));
  }, [dispatch]);

  return (
    <div
      className={`listing-sidebar-sticky-new ${
        isMobileSidebar ? "mobile-view" : ""
      }`}
    >
      <div className="listing-page-sidebar-new">
           <div className="catering-banner">
          {cateringBannerImage ? <img src={cateringBannerImage} alt="Catering Product" /> : null} 
        </div>
        {departmentTree && departmentTree.length ? (
          <div className="department-list">
            <div
              onClick={() => setShowDepartmentTree(!isShowDepartmentTree)}
            >
              <h2>
                {isCateringDepartment
                  ? departmentTree[0] && departmentTree[0].text
                  : "Departments"}
              </h2>
            </div>
            <div>
              <DepartmentListItemNew
                isShowDepartmentTree={isShowDepartmentTree}
                departmentTree={departmentTree}
                redirectBaseUrl={redirectBaseUrl}
                querySearchKey={querySearchKey}
              />
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default SidebarNew;
